import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import { BiTrip, BiCloudUpload } from "react-icons/bi";
import { RxExternalLink } from "react-icons/rx";
import HelpButton from "../components/HelpButton";

import User from "./User";
import Vehicle from "./Vehicle";
import DashboardButton from "./DashboardButton";
import DialogWrapper from "../components/Dialog/DialogWrapper";
import Loader from "../components/Loader";
import Store from "../SessionStorage";

import {
  sessionStorageAction,
  fetchAltimaId,
} from "Utilities";
import { getImageAssetUrl } from "Utilities/url";
import { TUTORIALS_LINK } from "../constants/links";

export class Dashboard extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoadingDataClient: true,
      isLoadingDataAuto: true,
      firstName: "",
      lastName: "",
      mailClient: "",
      numClientPrima: "",
      numClientAltima: "",
      numContract: "",
      productKey: "autoUsage",
      modelText: "",
      brandText: "",
      version: "",
      immatriculation: "",
      codeSRA: "",
      isLoggedIn: false,
      errorDialog: false,
      completedLoading: false,
    };
  }

  static propTypes = {
    accessToken: PropTypes.string.isRequired,
  };

  componentDidMount = () => {
    Store.set(
      sessionStorageAction.dashboard.accessToken,
      this.props.accessToken
    );

    if (
      Store.get(sessionStorageAction.dashboard.client.numContract) &&
      Store.get(sessionStorageAction.dashboard.vehicle.version)
    ) {
      this.setState({
        isLoggedIn: true,
        isLoadingDataClient: false,
        isLoadingDataAuto: false,
        completedLoading: true,
      });
      fetchAltimaId(
        Store.get(sessionStorageAction.dashboard.client.numClient)
      ).then((id) => {
        this.setState({ numClientAltima: id });
        Store.set(sessionStorageAction.dashboard.client.numAltima, id);
      });
    } else {
      fetch(
        `${window.location.origin}/particuliers/auto/assurance-auto-usage/espace-client/api/on-demand/userinfo?accessToken=${this.props.accessToken}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        }
      )
        .then((r) => r.json())
        .then((userInfo) => this.setState({ mailClient: userInfo[0].email }))
        .then(() => {
          fetch(
            `${window.location.origin}/particuliers/auto/assurance-auto-usage/espace-client/api/on-demand/user-info-contract`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
                Authorization: `Bearer ${this.props.accessToken}`,
              },
              body: JSON.stringify({
                mail: this.state.mailClient,
                productKey: this.state.productKey,
              }),
            }
          )
            .then((r) => r.json())
            .then((userInfoContract) => {
              if (!userInfoContract.length) {
                this.setState({ errorDialog: true });
              } else {
                const {
                  firstName,
                  lastName,
                  clientID,
                  contractID,
                  codeSRA,
                  immatriculation,
                  codeProduit
                } = userInfoContract[0];

                fetchAltimaId(clientID).then((id) => {
                  this.setState({ numClientAltima: id });
                  Store.set(
                    sessionStorageAction.dashboard.client.numAltima,
                    id
                  );
                });

                this.setState(
                  {
                    firstName,
                    lastName,
                    numClientPrima: clientID,
                    numContract: contractID,
                    codeSRA,
                    immatriculation,
                    isLoadingDataClient: false,
                  },
                  () => {
                    Store.set(
                      sessionStorageAction.dashboard.client.firstName,
                      firstName
                    );
                    Store.set(
                      sessionStorageAction.dashboard.client.lastName,
                      lastName
                    );
                    Store.set(
                      sessionStorageAction.dashboard.client.email,
                      this.state.mailClient
                    );
                    Store.set(
                      sessionStorageAction.dashboard.client.numClient,
                      clientID
                    );
                    Store.set(
                      sessionStorageAction.dashboard.client.numContract,
                      contractID
                    );
                    Store.set(
                      sessionStorageAction.dashboard.vehicle.immatriculation,
                      immatriculation
                    );
                    Store.set(
                      sessionStorageAction.dashboard.vehicle.codeSRA,
                      codeSRA
                    );
                    Store.set(
                      sessionStorageAction.dashboard.client.codeProduit,
                      codeProduit
                    );
                  }
                );
              }
            })
            .then(() => {
              fetch(
                `${window.location.origin}/particuliers/auto/assurance-auto-usage/espace-client/api/cars/${this.state.codeSRA}`,
                {
                  method: "GET",
                  headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json",
                  },
                }
              )
                .then((r) => r.json())
                .then((infosVehicle) => {
                  const { model, brand, version } = infosVehicle[0];

                  this.setState(
                    {
                      modelText: model ? model.label : "",
                      brandText: brand ? brand.label : "",
                      version,
                      isLoadingDataAuto: false,
                    },
                    () => {
                      const { modelText, brandText, version } = this.state;
                      Store.set(
                        sessionStorageAction.dashboard.vehicle.modelText,
                        modelText
                      );
                      Store.set(
                        sessionStorageAction.dashboard.vehicle.brandText,
                        brandText
                      );
                      Store.set(
                        sessionStorageAction.dashboard.vehicle.version,
                        version
                      );
                    }
                  );
                })
                .then(() => this.setState({ completedLoading: true }));
            });
        });
    }
  };

  logout = () => {
    window.sessionStorage.clear();
    window.location.href =
      "/particuliers/auto/assurance-auto-usage/espace-client";
  };

  render() {
    const {
      firstName,
      lastName,
      mailClient,
      numClientAltima,
      numContract,
      modelText,
      brandText,
      version,
      immatriculation,
      isLoggedIn,
      isLoadingDataClient,
      isLoadingDataAuto,
      completedLoading,
    } = this.state;

    const token = Store.get(sessionStorageAction.dashboard.accessToken);

    const displayedFirstName = isLoggedIn ? Store.get(sessionStorageAction.dashboard.client.firstName) : firstName;
    const displayedLastName = isLoggedIn ? Store.get(sessionStorageAction.dashboard.client.lastName) : lastName;
    const displayedEmail = isLoggedIn ? Store.get(sessionStorageAction.dashboard.client.email) : mailClient;

    return (
      <div className="admin-dashboard-container">
        <div
          className="admin-dashboard-header"
          style={{ backgroundImage: `url(${getImageAssetUrl("header-minute.jpeg")}` }}
        >
          <div className="admin-dashboard-header-blur" />
          <span className="admin-dashboard-header-title">Votre espace personnel</span>
          <a
            className="admin-dashboard-deconnection admin-dashboard-header-button"
            onClick={this.logout}
            title="Déconnexion"
          >
            <span>Déconnexion</span>
            <i className="material-icons">power_settings_new</i>
          </a>
        </div>

        <div className="admin-dashboard-card">
          <div className="admin-dashboard-avatar">
            {(isLoadingDataClient) ? "" : (displayedFirstName[0] + displayedLastName[0]).toUpperCase()}
          </div>
          <h1 className="admin-dashboard-name">
            {displayedFirstName}
            &nbsp;
            {displayedLastName}
          </h1>
          <div className="admin-dashboard-infos">
            {isLoadingDataClient
              ? <Loader/>
              : <User
                isLoggedIn={isLoggedIn}
                numClientAltima={numClientAltima}
                numContract={numContract}
                email={displayedEmail}
              />
            }
            {isLoadingDataAuto
              ? <Loader/>
              : <Vehicle
                isLoggedIn={isLoggedIn}
                brandText={brandText}
                modelText={modelText}
                immatriculation={immatriculation}
                version={version}
              />
            }
          </div>
          <a href={TUTORIALS_LINK} target="_blank">
            <div
              className="admin-dashboard-banner"
              style={{ backgroundImage: `url(${getImageAssetUrl("tuto.jpeg")}` }}
            >
              <div className="admin-dashboard-banner-blur" />
              <div className="admin-dashboard-banner-text">
                En cas de problème avec mon application,
                <br/>
                <div className="admin-dashboard-banner-text-icon">
                  je&nbsp;consulte&nbsp;<u>les&nbsp;tutoriels</u>
                  &nbsp;
                  <RxExternalLink size={16} />
                </div>
              </div>
            </div>
          </a>
          <div className="admin-dashboard-infos">
            <DashboardButton
              link={`/particuliers/auto/assurance-auto-usage/espace-client/declarer-mes-trajets?token=${token}`}
              description={"En cas de problème avec mon téléphone ou l'application, j'anticipe mes déplacements"}
              icon={<BiTrip size={30} />}
              fullWidth
              maxWidth={320}
            >
              Déclarer mes&nbsp;trajets
            </DashboardButton>
            <DashboardButton
              link={`/particuliers/auto/assurance-auto-usage/espace-client/pieces-justificatives?token=${token}`}
              description={<Fragment>Pour finaliser ma souscription <br/> ou compléter mon dossier</Fragment>}
              icon={<BiCloudUpload size={30} />}
              fullWidth
              maxWidth={320}
            >
              Envoyer mes&nbsp;documents
            </DashboardButton>
          </div>
        </div>

        <HelpButton
          link={`/particuliers/contact`}
          maxWidth={200}
        />

        <DialogWrapper
          title="Ooups, une erreur est survenue !"
          handleCloseDialog={() =>
            this.setState({ errorDialog: false }, () => this.logout())
          }
          isOpen={this.state.errorDialog}
          message="Veuillez vous reconnecter"
        />
      </div>
    );
  }
}
